var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTimer(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.50021 1H6.50021V2H9.50021V1ZM8.50021 5.5H7.50021V10H8.50021V5.5ZM13.2902 3.79506L14.0002 4.50006L12.7552 5.74506C13.4639 6.96028 13.6772 8.40184 13.3507 9.77022C13.0243 11.1386 12.1831 12.3286 11.0021 13.0929C9.82108 13.8573 8.39097 14.1372 7.00891 13.8746C5.62685 13.612 4.39911 12.827 3.58078 11.6827C2.76244 10.5384 2.41643 9.12284 2.61464 7.73008C2.81285 6.33733 3.54004 5.07448 4.64511 4.20393C5.75018 3.33337 7.14818 2.92205 8.54863 3.05541C9.94908 3.18877 11.2443 3.85657 12.1652 4.92006L13.2902 3.79506ZM5.50015 12.2417C6.24017 12.7361 7.1102 13.0001 8.00021 13.0001C9.19369 13.0001 10.3383 12.526 11.1822 11.682C12.0261 10.8381 12.5002 9.69353 12.5002 8.50006C12.5002 7.61004 12.2363 6.74001 11.7418 5.99999C11.2474 5.25997 10.5446 4.68319 9.72229 4.3426C8.90002 4.002 7.99522 3.91289 7.12231 4.08652C6.24939 4.26016 5.44757 4.68874 4.81823 5.31808C4.1889 5.94741 3.76031 6.74924 3.58668 7.62215C3.41305 8.49506 3.50216 9.39987 3.84276 10.2221C4.18335 11.0444 4.76013 11.7472 5.50015 12.2417Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTimer);
export default __webpack_public_path__ + "static/media/timer.f50469ec70e1e76ebc7ade4c1dc37d57.svg";
export { ForwardRef as ReactComponent };